<template>
    <div class="engineer-overtime">
        <div class="engineer-overtime__header">
            <h1 class="engineer-overtime__title">
                Overtime
            </h1>
        </div>
        <div class="engineer-overtime__list">
            <p v-if="loaded && logs.length === 0">
                No overtime logs yet
            </p>
            <div
                class="engineer-overtime__month"
                v-for="month in months"
                :key="month.date"
            >
                <div class="engineer-overtime__month-heading">
                    <span class="engineer-overtime__month-date">{{ month.date }}</span>
                    <span>Overtime: {{ month.total | minsToHours }}</span>
                </div>
                <overtime-row
                    v-for="log in month.logs"
                    :key="log.id"
                    :log="log"
                />
            </div>
            <p v-if="loading">
                Loading...
            </p>

            <button
                class="btn btn-primary"
                @click="loadMore"
                v-if="canLoadMore"
            >
                Load More
            </button>
        </div>

        <button
            class="btn floating-new-btn"
            @click="newOvertime"
        >
            <i class="fa fa-plus" />
        </button>

        <button
            class="btn floating-refresh-btn"
            @click="loadOvertimeLogs"
        >
            <i
                class="fas fa-sync-alt"
                :class="{'fa-spin' : loading}"
            />
        </button>
    </div>
</template>

<script>
import OvertimeService from '../../services/OvertimeService';
import OvertimeRow from './OvertimeRow';
export default {
    components: {
        OvertimeRow,
    },
    data () {
        return {
            logs: [],
            params: {
                page: 1,
            },
            total: 0,
            loading: false,
            loaded: false,
        };
    },
    computed: {
        canLoadMore () {
            return this.logs.length < this.total;
        },
        months () {
            const months = {};
            this.logs.forEach(log => {
                const month = window.moment(log.start_time).format('MMM YYYY');
                if (!months[month]) {
                    months[month] = [];
                }
                months[month].push(log);
            });

            const monthsArray = [];

            for (const month in months) {
                let total = 0;
                months[month].forEach(log => {
                    total += log.overtime_mins || 0;
                });
                monthsArray.push({
                    date: month,
                    logs: months[month],
                    total: total,
                });
            }

            return monthsArray;
        },
    },
    mounted () {
        this.loadOvertimeLogs();
    },
    methods: {
        newOvertime () {
            this.$router.push({name: 'engineer.overtime.new'});
        },
        loadOvertimeLogs () {
            this.loading = true;
            OvertimeService.engineer(this.params).then(res => {
                this.logs = this.logs.concat(res.data.data);
                this.total = res.data.total;
                this.loading = false;
                this.loaded = true;
            });
        },
        loadMore() {
            this.params.page++;
            this.loadOvertimeLogs();
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/engineer/OvertimeIndex.vue